<template>
  <div class="home-advantage">
    <nav-header :activeIndex="4" />
    <main class="home-advantage-content">
      <select-us />
    </main>
  </div>
</template>

<script>
  import SelectUs from '@/common-components/select-us'
  import NavHeader from '@/common-components/nav-header'
  export default {
    name: 'home-advantage',
    components: {
      SelectUs, NavHeader
    },
    methods: {
      // 路由跳转
      navigatorRoute (path) {
        let router = this.$router.resolve({
          name: path
        })
        window.open(router.href)
      }
    }
  }
</script>

<style lang='stylus'>
  @import '../../styles/constant.styl'
  .home-advantage {
    &-content {
      margin-top .72rem
      .title {
        width: 9.6rem
        margin 0 auto
        font-size: .36rem
        padding-left .16rem
        border-left .04rem solid #ed6c00
        margin-bottom .83rem
        text-align left !important
      }
      .line {
        display none
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/advantage/advantage.vue